import React from "react";
import useBulkAction from "../../hooks/useBulkAction";
import { Alert, Button } from "antd";
import "./BulkActionAlert.scss";
import { HEIGHT_BULK_REMOVE_HEADER } from "../../constants";
import { useTranslation } from "react-i18next";
import BulkActionButton from "./BulkActionButton";
import useBulkActionValidation from "../../hooks/useBulkActionValidation";

const BulkActionAlert = () => {
  const {
    removeRows,
    rejectRows,
    reExportRows,
    reprocessRows,
    unassignRows,
    selectedRows,
    resetRows,
    isProcessing,
    processingAction,
  } = useBulkAction();

  const { t } = useTranslation("overview");

  const {
    removeConfig,
    rejectConfig,
    reExportConfig,
    reApproveConfig,
    reprocessConfig,
    unassignConfig,
    showRemove,
    showReject,
    showReExport,
    showReApprove,
    showReprocess,
    showUnassign,
  } = useBulkActionValidation(selectedRows);

  if (!selectedRows.length) {
    return null;
  }

  return (
    <Alert
      className="bulk-action-alert"
      style={{ height: `${HEIGHT_BULK_REMOVE_HEADER}px` }}
      message={
        <div className="bulk-action-alert__container">
          <div>
            <span className="bulk-action-alert__description">
              {selectedRows.length}{" "}
              {selectedRows.length > 1
                ? t("bulkActionAlert.descriptionMultiple")
                : t("bulkActionAlert.description")}
            </span>
          </div>
          <div>
            <>
              {showRemove && (
                <BulkActionButton
                  config={removeConfig}
                  onClick={removeRows}
                  icon={<i className="bi bi-trash" />}
                  label={t("bulkActionAlert.removeLink")}
                />
              )}
              {showReject && (
                <BulkActionButton
                  config={rejectConfig}
                  onClick={rejectRows}
                  icon={<i className="bi bi-hand-thumbs-down" />}
                  label={t("bulkActionAlert.rejectLink")}
                />
              )}
              {showReExport && (
                <BulkActionButton
                  config={reExportConfig}
                  onClick={() => reExportRows(false, false)}
                  icon={<i className="bi bi-arrow-clockwise" />}
                  label={t("bulkActionAlert.reExportLink", "Re-export")}
                  loading={isProcessing && processingAction === "reexport"}
                  loadingLabel={t(
                    "bulkActionAlert.reExportingLink",
                    "Exporting...",
                  )}
                />
              )}
              {showReApprove && (
                <BulkActionButton
                  config={reApproveConfig}
                  onClick={() => reExportRows(false, true)}
                  icon={<i className="bi bi-check-circle" />}
                  label={t("bulkActionAlert.reApproveLink", "Re-approve")}
                  loading={isProcessing && processingAction === "reapprove"}
                  loadingLabel={t(
                    "bulkActionAlert.reApprovingLink",
                    "Approving...",
                  )}
                />
              )}
              {showReprocess && (
                <BulkActionButton
                  config={reprocessConfig}
                  onClick={reprocessRows}
                  icon={<i className="bi bi-arrow-repeat" />}
                  label={t("bulkActionAlert.reprocessLink", "Reprocess")}
                  loading={isProcessing && processingAction === "reprocess"}
                  loadingLabel={t(
                    "bulkActionAlert.reprocessingLink",
                    "Processing...",
                  )}
                />
              )}
              {showUnassign && (
                <BulkActionButton
                  config={unassignConfig}
                  onClick={unassignRows}
                  icon={<i className="bi bi-person-dash" />}
                  label={t("bulkActionAlert.unassignLink", "Unassign")}
                  loading={isProcessing && processingAction === "unassign"}
                  loadingLabel={t(
                    "bulkActionAlert.unassigningLink",
                    "Unassigning...",
                  )}
                />
              )}
            </>
          </div>
          <div>
            <Button
              type="link"
              className="bulk-action-alert__link"
              onClick={resetRows}
            >
              {t("bulkActionAlert.cancelLink")}
            </Button>
          </div>
        </div>
      }
    />
  );
};

export default BulkActionAlert;
